module.exports = __webpack_public_path__ + "static/media/memory-click.9123608c.png";